import React, { useState } from "react";
import "./OurGallery.css";
import { FaLanguage } from "react-icons/fa";

const OurGallery = () => {
  const [isTamil, setIsTamil] = useState(false);

  const galleryItems = [
    {
      title: isTamil ? "திருமண உதவி" : "Marriage Support",
      image: "mar.jpg",
      description: isTamil
        ? "திருமண செலவுகளுக்காக தேவையுள்ளவர்களுக்கு அடிப்படை உதவி வழங்குகிறோம்."
        : "Helping those in need with essential support for marriage expenses.",
    },
    {
      title: isTamil ? "கல்வி உதவி" : "Educational Support",
      image: "edu.jpg",
      description: isTamil
        ? "பின்தங்கிய மாணவர்களுக்கு பள்ளி மற்றும் கல்லூரி கல்வி உதவி."
        : "Providing school and college support for underprivileged students.",
    },
    {
      title: isTamil ? "மருத்துவ உதவி" : "Medical Support",
      image: "medic.jpg",
      description: isTamil
        ? "மருந்துகள், மருத்துவமனை கட்டணங்கள் மற்றும் அவசர தேவைகளுக்கு உதவி."
        : "Offering help with medications, hospital fees, and emergencies.",
    },
    {
      title: isTamil ? "மூத்த குடிமக்கள் உதவி" : "Elder People Support",
      image: "elder.avif",
      description: isTamil
        ? "மூத்த குடிமக்களுக்கு உறைவிடம் மற்றும் உதவிகளை வழங்குகிறோம்."
        : "Caring for senior citizens through shelter and aid.",
    },
  ];

  return (
    <section id="gallery" className="gallery-section">
      <div className="gallery-header">
        <h2 className="gallery-title">
          {isTamil ? "எங்கள் சேவைகள்" : "Our Services"}
        </h2>
        <button
          onClick={() => setIsTamil(!isTamil)}
          className="gallery-translate-btn"
        >
          <FaLanguage />
          {isTamil ? "Translate to English" : "Translate to தமிழ்"}
        </button>
      </div>

      <div className="gallery-grid">
        {galleryItems.map((item, index) => (
          <div key={index} className="gallery-card">
            <img
              src={item.image}
              alt={item.title}
              className="gallery-image"
            />
            <h3 className="gallery-heading">{item.title}</h3>
            <p className="gallery-description">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurGallery;
